(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-v2-reviews"] && !Shopify.designMode) return;
  try {
    
// Visual-only active state for review filter tabs (Phase 2: wire to Okendo tag filtering)
document.querySelectorAll('.pdp-v2-reviews__filter-tab').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var group = this.closest('.pdp-v2-reviews__filter-tabs');
    group.querySelectorAll('.pdp-v2-reviews__filter-tab').forEach(function(b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
    this.classList.add('is-active');
    this.setAttribute('aria-pressed', 'true');
  });
});

  } catch(e) { console.error(e); }
})();
})();
